module.exports = __webpack_public_path__ + "img/QB.a30dad93.png";